export default __webpack_public_path__ + "static/media/background-letter-2.0d53b349.png";